import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom';
import styles from './RequestsTile.scss';// to import local scss fle


class SchoolTile extends Component {

  static propTypes = {
    request: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
    this.getStyles = this.getStyles.bind(this);
  }
    /* eslint-disable */
  getStyles(value) {
    let returnValue = 'interestedButton';
    if (value === 'FILL QUESTIONAIRE') {
      returnValue = 'greenButton';
    }
    if (value === 'INVITE TO CAMP') {
      returnValue = 'inviteToCampButton';
    }
    if (value === 'NEED MORE FILMS') {
      returnValue = 'needMoreFilmsButton';
    }
    if (value === 'ADDED TO WATCHLIST') {
      returnValue = 'addedToWatchListButton';
    }
    if (value === 'IGNORED') {
      returnValue = 'ignoredButton';
    }
    if (value === 'SEND CONTACT INFO') {
      returnValue = 'sendContactInfoButton';
    }
    if (value === 'SA SENT CONTACT INFO') {
        returnValue = 'addedToWatchListButton';
    }
    return returnValue;
  }
    /* eslint-disable */
  render() {
    const { request } = this.props;
    const convo = request.get('conversation');
    const last = convo.last();
    const flag = last.get('link') && last.get('link').length > 0;
    let link = '';

    if (flag) {
      link = last.get('link');
      link = link.startsWith('http') ? link : `http://${link}`;
    }
    if(!link){
      link = request.get('question_link');
    }

    return (
      <div className={styles.container}>
        <div className={styles.tile}>
          {/* eslint-disable */}
                  <img className={styles.colgeIcon}
                       src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png"
                       alt="college-icon"/>
                  {/*<img className={styles.colgeIcon} src={props.request.get('college_image')}
                     onError="this.onerror=null;this.src='https://media.dev.myrecruitboard.com/Images/defaultCollege.png;"
                     alt="college-icon"/>*/}
                  <div className={styles.collegeName}>{request.get('college_name') || 'College Name'} < br/>
                      <span className={styles.lightText}>{request.get('city')}</span> <br />
                  </div>
                  <span className={styles.lightText}>{request.get('division')}</span>
                      <div className={styles.veryLightText}>
                        {(request.get('status') !== undefined && last.get('action') === 'INTERESTED' ) ?
                          <span className={styles.boldText}>{request.get('status')} </span> :
                          last.get('action') === 'INTERESTED' ? 'Awaiting response' : ''}
                          {last.get('action') === 'FILL QUESTIONAIRE' ? 'Complete Recruiting Questionaire' : ''}
                          {last.get('action') === 'IGNORED' ? 'Not Interested' : ''}
                          {last.get('action') === 'SEND CONTACT INFO' ? 'Check mail to send info' : ''}
                          {last.get('action') === 'ADDED TO WATCHLIST' ? 'Added to my Watchlist' : ''}
                          {last.get('action') === 'NEED MORE FILMS' ? 'Need more films' : ''}
                          {last.get('action') === 'INVITE TO CAMP' ? 'Attend Our Camp' : ''}
                          {last.get('action') === 'SA SENT CONTACT INFO' ? 'Your info has been sent' : ''}
                      </div>
                  <div className={cn(this.getStyles(convo.get(convo.size - 1).get('action')))}>
                      {last.get('action') === 'INTERESTED' ?
                              <a target="_blank">
                                  {last.get('action')}
                              </a>
                          : ''
                      }
                      {last.get('action') === 'IGNORED' ?
                          <a target="_blank">
                              {last.get('action')}
                          </a>
                          : ''
                      }
                      {last.get('action') === 'SEND CONTACT INFO' ?
                          <a>
                              {last.get('action')}
                          </a>
                          : ''
                      }
                      {last.get('action') === 'SA SENT CONTACT INFO' ?
                          <a>
                              CONTACT INFO SENT
                          </a>
                          : ''
                      }
                      {last.get('action') === 'FILL QUESTIONAIRE' ?
                          <a href={link} target="_blank">
                              {last.get('action')}
                          </a>
                          : ''
                      }
                      {last.get('action') === 'NEED MORE FILMS' ?
                          <Link to="/view/athlete" >
                              {last.get('action')}
                          </Link>
                          : ''
                      }
                      {last.get('action') === 'ADDED TO WATCHLIST' ?
                          <a>
                              {last.get('action')}
                          </a>
                          : ''
                      }
                      {last.get('action') === 'INVITE TO CAMP' ?
                          <a>
                              {last.get('action')}
                          </a>
                          : ''
                      }
                  </div>
              </div>
              {/* eslint-enable */}
      </div>
    );
  }
}


export default SchoolTile;



// WEBPACK FOOTER //
// ./src/components/RequestsTile/RequestsTile.js